import { environment } from 'app/environments/environment';

const API_BASE_URLS = [environment.URLServicio, environment.URLServicioAdmin];

/**
 *
 * Función utilizada para validar si la URL de la petición pertenece a alguno de los APIs configurados en el entorno
 */
export function isConfiguredApiRequest(requestUrl: string): boolean {
  let target: URL;
  try {
    target = new URL(requestUrl);
  } catch {
    return false;
  }

  return API_BASE_URLS.some((baseUrl) => {
    try {
      const base = new URL(baseUrl);
      return target.origin === base.origin && target.pathname.startsWith(base.pathname);
    } catch {
      return false;
    }
  });
}
